import type { ISerialize } from '@/objects/ISerialize';
import { ContestantAndRaceContestantTime } from './ContestantAndRaceContestantTime';
import { formatDateIso } from '@/utilities/dateutils';

export class RaceContestantWithTimes implements ISerialize {
    public ID: number;

    public ContestantID: number;

    public RaceID: number;

    public StartTime: Date | null;

    public Times: ContestantAndRaceContestantTime[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        ID?: number;
        ContestantID?: number;
        RaceID?: number;
        StartTime?: Date | null;
        Times?: ContestantAndRaceContestantTime[];
    }) {
        this.ID = values.ID ?? 0;

        this.ContestantID = values.ContestantID ?? 0;

        this.RaceID = values.RaceID ?? 0;

        this.StartTime = values.StartTime ?? null;

        this.Times = values.Times ?? [];
    }

    public serialize(): string {
        return (
            '{' +
            `"ID": ${JSON.stringify(this.ID)}` +
            ',' +
            `"ContestantID": ${JSON.stringify(this.ContestantID)}` +
            ',' +
            `"RaceID": ${JSON.stringify(this.RaceID)}` +
            ',' +
            `"StartTime": ${this.StartTime ? '"' + formatDateIso(this.StartTime) + '"' : null}` +
            ',' +
            `"Times": [ ${this.Times.map((x) => (!x ? null : x?.serialize()))} ]` +
            '}'
        );
    }

    /**
     * Creates an instance of RaceContestantWithTimes from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        ID?: number;
        ContestantID?: number;
        RaceID?: number;
        StartTime?: Date | null;
        Times?: ContestantAndRaceContestantTime[];
    }): RaceContestantWithTimes {
        return new RaceContestantWithTimes(values);
    }

    public static _FromServerJson(json: any): RaceContestantWithTimes {
        return new RaceContestantWithTimes({
            ID: json.ID,
            ContestantID: json.ContestantID,
            RaceID: json.RaceID,
            StartTime: json.StartTime ? (json.StartTime instanceof Date ? json.StartTime : new Date(json.StartTime)) : null,
            Times: json.Times?.map((x: any) => ContestantAndRaceContestantTime._FromServerJson(x)),
        });
    }

    /**
     * Creates an instance of RaceContestantWithTimes from another instance of RaceContestantWithTimes.
     * @param other The RaceContestantWithTimes you want to clone
     * @returns A cloned RaceContestantWithTimes
     */
    public static FromOther(other: RaceContestantWithTimes): RaceContestantWithTimes {
        return RaceContestantWithTimes._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return RaceContestantWithTimes.FromOther(this);
    }

    static NAME_OF_CLASS = 'RaceContestantWithTimes';
}
